import { useState } from "react";
import {
    Box,
    BoxProps,
    Collapse,
    Flex,
    Icon,
    IconButton,
    Input,
    InputGroup,
    InputLeftElement,
    InputRightElement,
} from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";
import { SelectFieldV2 } from "../../components/selectField/SelectFieldV2";
import {
    gamCampaignSearchFilterVar,
    GamCampaignStatusFilterType,
    gamCampaignStatusFilterVar,
} from "../../lib/cache";
import { useReactiveVar } from "@apollo/client";
import { MdClear } from "react-icons/md";
import { ActionLabel } from "../../components/actionLabel/ActionLabel";


export const GamCampaignHomeSearchFilter = (props: BoxProps) => {
  // const currentUser = useReactiveVar(userDetailsVar);
  const statusFilter = useReactiveVar(gamCampaignStatusFilterVar);
  const searchFilter = useReactiveVar(gamCampaignSearchFilterVar);
  const [searchState, setSearchState] = useState(searchFilter);

  const statusFilterOptions: {
    label: string;
    value: GamCampaignStatusFilterType;
  }[] = [
    { label: "View All", value: "ALL" },
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ];

  const handleStatusFilterChange = ({
    value,
  }: {
    value: GamCampaignStatusFilterType;
  }) => {
    gamCampaignStatusFilterVar(value);
  };

  const currentFilter = statusFilterOptions.find(
    ({ value }) => value === statusFilter
  );

  return (
    <Flex
      justifyContent={[null, null, "space-between", null, null]}
      flexDirection={["column", null, "row", null, null]}
      {...props}
    >
      <Box minW={"35%"}>
        <InputGroup>

          <InputLeftElement pointerEvents={"none"}>
            <Icon
              as={FiSearch}
              w={[3, null, null, 4, null]}
              h={[3, null, null, 4, null]}
            />
          </InputLeftElement>
          <Input
            variant="lightBox"
            placeholder={"Search campaigns"}
            value={searchState}
            onChange={(e) => {
              setSearchState(e.target.value);
              gamCampaignSearchFilterVar(e.target.value);
            }}
            // onKeyPress={(e) => {
            //   if (e.key === "Enter") {
            //     campaignSearchFilterVar(searchState);
            //   }
            // }}
          />
          <InputRightElement>
            <Collapse in={!!searchState}>
              <IconButton
                aria-label={"clear-search-query"}
                variant={"unstyled"}
                pl={2}
                onClick={() => {
                  gamCampaignSearchFilterVar("");
                  setSearchState("");
                }}
                icon={
                  <Icon
                    as={MdClear}
                    w={[3, null, null, 4, null]}
                    h={[3, null, null, 4, null]}
                  />
                }
              />
            </Collapse>
          </InputRightElement>
        </InputGroup>
      </Box>
      <ActionLabel label={"filter by"} mt={[2, null, 0, null, null]}>
        <Box
          minW={36}
          w={"100%"}
        >
          <SelectFieldV2
            styles={{
              valueContainer: (base) => ({
                ...base,
                backgroundColor: "white",
              }),
              indicatorsContainer: (base) => ({
                ...base,
                backgroundColor: "white",
              }),
              menu: (base) => ({
                ...base,
                // marginTop: "0px",
                width: "100%",
                // borderWidth: "1px",
              }),
            }}
            isMulti={false}
            value={currentFilter}
            options={statusFilterOptions}
            onChange={handleStatusFilterChange}
          />
        </Box>
      </ActionLabel>
    </Flex>
  );
}
